<!--
Copyright (c) 2025-2026, NVIDIA CORPORATION.  All rights reserved.

NVIDIA CORPORATION and its licensors retain all intellectual property
and proprietary rights in and to this software, related documentation
and any modifications thereto.  Any use, reproduction, disclosure or
distribution of this software and related documentation without an express
license agreement from NVIDIA CORPORATION is strictly prohibited.
-->

<!-- Header with remaining info -->
<div class="grid">
    <nv-hig-list-item
        class="wrap-trail-upto-s2"
        [class.warning]="isWarningState"
        [cardData]="resourceRemainingCardData"
    >
    </nv-hig-list-item>
</div>
<!-- Progress bar -->
<div class="progress-bar-container">
    @if (resourceType === 'decremental') {
        <mat-progress-bar
            [class.progress-bar-accent]="isFullResourceState"
            [class.progress-bar-warn]="!isFullResourceState"
            role="progressbar"
            [attr.tabindex]="null"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-valuemin]="ariaValueMin || null"
            [attr.aria-valuenow]="progressValue || null"
            [attr.aria-valuemax]="ariaValueMax || null"
            [attr.aria-valuetext]="ariaValueText || null"
            mode="determinate"
            [value]="progressValue"
        ></mat-progress-bar>
    }
    @if (resourceType === 'incremental') {
        <mat-progress-bar
            class="progress-bar-default"
            role="progressbar"
            [attr.tabindex]="null"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-valuenow]="progressValue || null"
            [attr.aria-valuemin]="ariaValueMin || null"
            [attr.aria-valuemax]="ariaValueMax || null"
            [attr.aria-valuetext]="ariaValueText || null"
            mode="determinate"
            [value]="progressValue"
        ></mat-progress-bar>
    }
</div>
<!-- Total info -->
<div class="grid">
    <nv-hig-list-item class="wrap-trail-upto-s2" [cardData]="resourceTotalCardData"></nv-hig-list-item>
</div>
<div class="resource-warning">
    <nv-hig-list-insert [data]="warningMessageData"> </nv-hig-list-insert>
</div>
